import React, { useState } from 'react';

interface InviteTeammemberProps {
    onInvite: (email: string) => void;
}

const InviteTeammember: React.FC<InviteTeammemberProps> = ({ onInvite }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const validateEmail = (value: string) => {
        // Simple email regex
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        setError('');
    };

    const handleInviteClick = () => {
        if (!validateEmail(email)) {
            setError('Please enter a valid email address.');
            return;
        }
        onInvite(email);
        setEmail('');
    };

    return (
        <div className="flex items-start gap-2">
            <input
            type="email"
            value={email}
            onChange={handleInputChange}
            placeholder="Enter email address"
            aria-label="Email address"
            size={25}
            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
            onClick={handleInviteClick}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors whitespace-nowrap"
            title="Send an email to request a user to sign up to help with your workload"
            >
            Invite
            </button>
            {error && (
            <div className="text-red-600 text-sm absolute mt-12">
                {error}
            </div>
            )}
        </div>
    );
};

export default InviteTeammember;